import { Box, Divider, Flex, Paper, Text } from '@shared/components';
import { RoleUserList } from '@user-management/role-user-list';
import { RoleUserAdditionButton } from '@user-management/role-user-management';

export default function RoleUsersPage() {
  return (
    <Paper sx={{ flexGrow: 1, minHeight: '100%', display: 'flex', flexDirection: 'column' }}>
      <Flex
        sx={(theme) => ({
          justifyContent: 'space-between',
          p: theme.spacing(4, 6),
        })}
      >
        <Text variant='h3'>Users</Text>
        <RoleUserAdditionButton />
      </Flex>
      <Divider />
      <Box sx={{ p: (theme) => theme.spacing(6), flexGrow: 1 }}>
        <RoleUserList />
      </Box>
    </Paper>
  );
}
